/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Verify_Page_DescriptionInputs */

const fr_totp_verify_page_description = /** @type {(inputs: Totp_Verify_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre le code à 6 chiffres de ton application d'authentification.`)
};

/**

* @param {Totp_Verify_Page_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_verify_page_description = /** @type {((inputs?: Totp_Verify_Page_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Verify_Page_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_verify_page_description(inputs)
});